import { Component, OnDestroy, OnInit } from '@angular/core';
import { DestroyService } from '../../services/destroy/destroy.service';
import { ToastrService } from '../../services/toastr/toastr.service';
import { takeUntil } from 'rxjs';

interface Toast {
  id: number;
  title: string;
  message: string;
  type: string;
  icon: string;
  duration: number;
  progress: number;
  intervalId?: any;
}

@Component({
    selector: 'app-toastr',
    templateUrl: './toastr.component.html',
    styleUrls: ['./toastr.component.scss'],
    providers: [DestroyService],
    standalone: false
})
export class ToastrComponent implements OnInit, OnDestroy {
  toasts: Toast[] = [];
  private toastId = 0;

  constructor(private toastrService: ToastrService, private destroyService: DestroyService) {}

  ngOnInit(): void {
    this.getToastr();
    console.log('init');
    
  }

  getToastr() {
    this.toastrService.getToast()
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(toast => {
        const id = this.toastId++;
        const newToast: Toast = {
          id,
          title: toast.title,
          message: toast.message,
          type: toast.type,
          icon: toast.icon,
          duration: toast.duration,
          progress: 0
        };

        this.toasts.push(newToast);
        this.startProgress(newToast);
      });
  }

  startProgress(toast: Toast) {
    const intervalTime = 20;
    const step = 100 / (toast.duration / intervalTime);

    toast.intervalId = setInterval(() => {
      
      if (toast.progress >= 100) {
        this.closeToast(toast.id);
      } else {
        toast.progress += step;
      }
    }, intervalTime);
  }

  closeToast(id: number) {
    const index = this.toasts.findIndex(t => t.id === id);
    if (index !== -1) {
      clearInterval(this.toasts[index].intervalId);
      this.toasts.splice(index, 1);
    }
  }

  ngOnDestroy() {
    
    this.toasts.forEach(toast => clearInterval(toast.intervalId));
    this.toasts = [];
  }
}

